import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatNumber, formatPercentage } from '@/lib/utils/format';
import type { FunnelStage } from '../types/analytics.types';

const STAGE_LABELS: Record<string, string> = {
  CREATED: 'Creadas',
  SUBMITTED: 'Enviadas',
  APPROVED: 'Aprobadas',
  WON: 'Ganadas',
};

const STAGE_COLORS = ['bg-blue-400', 'bg-blue-500', 'bg-blue-600', 'bg-blue-700'];

interface ConversionFunnelProps {
  funnel: FunnelStage[];
}

export function ConversionFunnel({ funnel }: ConversionFunnelProps) {
  if (funnel.length === 0) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Embudo de Conversión</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-32 flex items-center justify-center text-muted-foreground text-sm">
            Sin datos del embudo para este periodo
          </div>
        </CardContent>
      </Card>
    );
  }

  const firstCount = funnel[0]?.count || 1;

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Embudo de Conversión</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {funnel.map((stage, index) => {
            const widthPct = Math.max((stage.count / firstCount) * 100, 8);
            const conversionPct = (stage.count / firstCount) * 100;
            const label = STAGE_LABELS[stage.stage] || stage.stage;
            const colorClass = STAGE_COLORS[index % STAGE_COLORS.length];

            return (
              <div key={stage.stage} className="space-y-1">
                <div className="flex items-center justify-between text-sm">
                  <span className="font-medium">{label}</span>
                  <div className="flex items-center gap-2">
                    <span className="font-semibold">{formatNumber(stage.count, 0)}</span>
                    <span className="text-muted-foreground text-xs">
                      ({formatPercentage(conversionPct, 0)})
                    </span>
                  </div>
                </div>
                <div className="h-8 bg-muted rounded-md overflow-hidden">
                  <div
                    className={`h-full ${colorClass} rounded-md transition-all duration-500 flex items-center justify-center`}
                    style={{ width: `${widthPct}%` }}
                  >
                    {widthPct > 20 && (
                      <span className="text-white text-xs font-medium">
                        {formatNumber(stage.count, 0)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
